import {getElementOffset} from './_utils';


export default class AdfSmoothScroll
{


    constructor ()
    {
        this.smoothScrollLinks = document.querySelectorAll( 'a[href^="#"]:not([href^="#keyword-section_"]:not(#btn-jump-main-content)) ' );



        if ( this.smoothScrollLinks.length > 0 )
        {
            this.bindSmoothScroll();
        }
    }


    bindSmoothScroll ()
    {
        Array.from( this.smoothScrollLinks )
            .forEach( ( el, i ) =>
            {
                el.addEventListener( 'click', this.scrollTo );
            } );
    }

    unbindSmoothScroll ()
    {
        Array.from( this.smoothScrollLinks )
            .forEach( ( el, i ) =>
            {
                el.removeEventListener( 'click', this.scrollTo );
            } );
    }

    resetSmoothScroll ()
    {
        this.unbindSmoothScroll();

        // update our array of links
        this.smoothScrollLinks = document.querySelectorAll( 'a[href^="#"] ' );

        this.bindSmoothScroll();
    }

    scrollTo ( event )
    {

        const clicked = event.target;
        const href = clicked.getAttribute('href');
        const foundMatchingDestination = document.querySelector(href);

        document.activeElement.blur();

        if(!foundMatchingDestination) {

            return true;
        }

        event.preventDefault();


        window.scrollTo( {
            top      : getElementOffset( foundMatchingDestination).top - 50,
            left     : 0,
            behavior : 'smooth',
        } );


        foundMatchingDestination.focus();
    }


}
